module.exports = __webpack_public_path__ + "media/audios/kid/lesson_8/audio_tpc8_plasticina-e6f3c42323fdfeaa03b316ab04ce168e.m4a";